import React from 'react'
import { useDispatch } from 'react-redux'
import CardContainer from './CardContainer'
import { S } from './Speakers'
import { ContentProps } from './GoodiebagContent'
import Bookmark from '../Bookmark'
import { GoodiebagType, MeetingData } from '../types'
import constants from '../../../constants/constants'
import useFetchAttendees from '../../attendees/useFetchAttendees'
import { formatName } from '../../../utils/profile'
import Icon from '../../../components/Icon'
import openChatModal from '../../chat/openChatModal'
import useSlug from '../../../hooks/useSlug'
import colors from '../../../constants/colors'
import { toLocalDateFormat, toLocalTimeFormat } from '../../../utils/datetime'

const MeetingExpertContent = ({ meeting }: { meeting: MeetingData }) => {
    const dispatch = useDispatch()
    const eventSlug = useSlug('eventSlug')
    const [host] = useFetchAttendees([meeting.host_id], true)
    const chatWithHost = () => dispatch(openChatModal(eventSlug, meeting.host_id))

    return (
        <S.Wrapper>
            <S.Link
                to={`/${eventSlug}/meetings/${meeting.slug}?meetingId=${meeting.id}`}
            >
                <div className="d-flex">
                    <S.Image src={host?.mugshot || constants.urlThumbnailDefault} />
                    <S.Content>
                        <S.Title className="text-cut">{meeting.title}</S.Title>
                        <S.Description>
                            {host && formatName(host)}
                        </S.Description>
                        <S.SubDescription>
                            <Icon
                                icon="calendarRange"
                                size={16}
                                color={colors.regentGray}
                                style={{margin: '0 3px 3px 0'}}
                            />
                            <span>{toLocalDateFormat(meeting.starts_at)}</span>
                            <div className="mr-3" />
                            <Icon
                                icon="clock"
                                size={16}
                                color={colors.regentGray}
                                style={{margin: '0 3px 3px 0'}}
                            />
                            <span>{`${toLocalTimeFormat(meeting.starts_at)} - ${toLocalTimeFormat(meeting.ends_at)}`}</span>
                        </S.SubDescription>
                    </S.Content>
                </div>
            </S.Link>

            <S.Actions>
                <Bookmark
                    item={{ id: meeting.id, type: GoodiebagType.MeetingExpert }}
                    style={{ margin: '0 20px' }}
                    size={20}
                />
                {meeting.enable_host_chat ? (
                    <Icon
                        icon="message"
                        size={20}
                        onClick={chatWithHost}
                        color={colors.icon}
                    />
                ) : (
                    <Icon
                        icon="message"
                        size={20}
                        color={colors.gray2}
                    />
                )}
            </S.Actions>
        </S.Wrapper>
    )
}

const MeetingExperts = ({ items }: ContentProps) => (
    <CardContainer>
        {items.map(({ meeting }) => (
            <MeetingExpertContent meeting={meeting} key={meeting.id} />
        ))}
    </CardContainer>
)

export default MeetingExperts
